import React from "react";
import "./LoginModal.css";

function LoginModal({ onLogin, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content modal-content-1">
        <div className="box-content">
            
        <h2 className="admin-login-title">Super Admin Login</h2>
        <input className="form-control input-name" type="text" placeholder="Username" />
        <input className="form-control input-password" type="text" placeholder="Password" />
        <button onClick={onLogin} className="login-btn">Login</button>
        <button onClick={onClose} className="close-btn">Close</button>
      </div>
      </div>
    </div>
  );
}

export default LoginModal;
